import React from 'react';
import { Homepage } from './containers/homepage';

import './App.css';
import './redesign.css';

function App() {
  return <Homepage />;
}

export default App;
